/**
 * True when persisted impact assessment was computed with a different calculation model
 * than the tenant's current effective configuration.
 *
 * @param {{ recovery?: { calculationModel?: string } }|null|undefined} impactAssessment
 * @param {{ calculationModel?: string }|null|undefined} effectiveConfig
 */
export function isImpactAssessmentModelStale(impactAssessment, effectiveConfig) {
    const persistedModel = impactAssessment?.recovery?.calculationModel;
    const currentModel = effectiveConfig?.calculationModel;
    if (!persistedModel || !currentModel) return false;
    return persistedModel !== currentModel;
}
